import { render } from "./BasePaginationButton.vue?vue&type=template&id=434aec7a"
import script from "./BasePaginationButton.vue?vue&type=script&lang=js"
export * from "./BasePaginationButton.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__